import { ProgramNode } from './program-node';

export class ProgramStep {
  public nodes: ProgramNode[];
}
